import { logUtil } from 'packages/src'

const logSystemUtil = logUtil

export default logSystemUtil
